import { Injectable } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import { throwError } from "rxjs";
import { BookingConfigService } from "./booking-config.service";

@Injectable({ providedIn: 'root' })
export class HandleBookingService {
    private _form: any;
    private hostPath: string;

    constructor(private fb: FormBuilder, private http: HttpClient, private bookingConfigService: BookingConfigService
    ) {
        this.hostPath = JSON.parse(this.bookingConfigService.getConfig().IDENTITY);
    }

    getForm() {
        return this._form;
    }

    initForm(site: string) {
        const siteKey = (site || 'flygets').toLowerCase();

        if (siteKey === 'skavsta') {
            this._form = this.fb.group({
                handleBookingGroup: this.fb.group({
                    email: ['', Validators.required],
                    bookingNumber: ['', Validators.required],
                }),
                details: this.fb.group({
                    firstname: ['', { validators: Validators.required, updateOn: "blur" }],
                    lastname: ['', { validators: Validators.required, updateOn: "blur" }],
                    cellular: ['', { validators: Validators.required, updateOn: "blur" }],
                    regNr: ['', { validators: [Validators.required, Validators.minLength(6)], updateOn: "blur" }],
                    email: [{ disabled: true }],
                    persons: ['', Validators.required],
                    baggage: ['false', Validators.required],
                    departureDate: [''],
                    departureTime: [''],
                    arrivalDate: [''],
                    arrivalTime: [''],
                    parkingSite: [''],
                    discount: ['']
                })
            });
        }
        else if (siteKey === 'quality hotel arlanda xpo parkering' || siteKey === 'quality-xpo-arlanda' || siteKey === 'quality' || siteKey === 'aiden hotel arlanda parkering' || siteKey === 'aiden-short-term' || siteKey === 'aiden') {
            this._form = this.fb.group({
                handleBookingGroup: this.fb.group({
                    email: ['', Validators.required],
                    bookingNumber: ['', Validators.required],
                }),
                details: this.fb.group({
                    firstname: ['', { validators: Validators.required, updateOn: "blur" }],
                    lastname: ['', { validators: Validators.required, updateOn: "blur" }],
                    cellular: ['', { validators: Validators.required, updateOn: "blur" }],
                    regNr: ['', { validators: [Validators.required, Validators.minLength(6)], updateOn: "blur" }],
                    email: [{ disabled: true }],
                    persons: ['', Validators.required],
                    baggage: ['false', Validators.required],
                    departureDate: [''],
                    departureTime: [''],
                    arrivalDate: [''],
                    arrivalTime: [''],
                    parkingSite: [''],
                    discount: ['']
                })
            });
        }
        else {
            this._form = this.fb.group({
                handleBookingGroup: this.fb.group({
                    email: ['', Validators.required],
                    bookingNumber: ['', Validators.required],
                }),
                details: this.fb.group({
                    cellular: ['', { validators: Validators.required, updateOn: "blur" }],
                    regNr: ['', { validators: [Validators.required, Validators.minLength(6)], updateOn: "blur" }],
                    persons: ['', Validators.required],
                    comment: ['', { updateOn: "blur" }],
                    arrivalTimeAtParking: ['', Validators.required],
                    contact: [false],
                    email: [{ disabled: true }],
                    baggage: ['false', Validators.required],
                    departureDate: ['', Validators.required],
                    departureTime: ['', Validators.required],
                    departureTimeAtParking: ['', Validators.required],
                    departureFlight: ['', Validators.required],
                    departureHotel: ['', Validators.required],
                    arrivalHotel: ['', Validators.required],
                    departureType: ['false'],
                    arrivalFlight: ['', Validators.required],
                    arrivalDate: ['', Validators.required],
                    arrivalTime: ['', Validators.required],
                    arrivalType: ['false'],
                    parkingSite: [''],
                    discount: ['']
                })
            });
        }

        if (site === 'mdpark') {
            this._form = this.fb.group({
                handleBookingGroup: this.fb.group({
                    email: ['', Validators.required],
                    bookingNumber: ['', Validators.required],
                }),
                details: this.fb.group({
                    cellular: ['', { validators: Validators.required, updateOn: "blur" }],
                    regNr: ['', { validators: [Validators.required, Validators.minLength(6)], updateOn: "blur" }],
                    persons: ['', Validators.required],
                    comment: ['', { updateOn: "blur" }],
                    arrivalTimeAtParking: ['', Validators.required],
                    contact: [false],
                    email: [{ disabled: true }],
                    baggage: ['false', Validators.required],
                })
            });
        }
    }

    getBookingDetails(email: string, bookingNumber: string) {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/SelfService/GetDetailsByOrderNumberEmail/`;
        return this.http
            .post<any>(URL, { "site": 'www.shuttlebuss.se', "ordernumber": bookingNumber, "email": email }, { headers })
            .pipe(map(booking => {
                return booking;
            }),
                catchError(this.handleError)
            );
    }

    public async cancelByOrderNumberEmail(orderNumber: string, email: string) {
        const model = {
            site: 'www.shuttlebuss.se',
            orderNumber,
            email,
        };

        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/SelfService/CancelByOrderNumberEmail`;
        const result = await this.http
            .post<any>(URL, model, { 'headers': headers })
            .toPromise();
        return result;
    }

    public async cancelAdditionalServices(orderNumber: string, email: string, additionalServices: string[] = []) {
        const model = {
            site: 'www.shuttlebuss.se',
            orderNumber,
            email,
            additionalServices
        };
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/SelfService/CancelAdditionalServiceByOrderNumberEmail
`;
        const result = await this.http
            .post<any>(URL, model, { 'headers': headers })
            .toPromise();
        return result;
    }

    public updateOrderByOrderNumberEmail(model: any) {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/SelfService/UpdateOrderByOrderNumberEmail`;
        const result = this.http
            .post<any>(URL, model, { 'headers': headers })
            .pipe(map(update => {
                return update
            }),
                catchError(this.handleError)
            );
        return result;
    }

    public updateBookingDetails(updates: any) {
        const model = {
            site: 'www.shuttlebuss.se',
            orderNumber: updates['orderNumber'] ?? '',
            carRegNumber: updates['carRegNumber'] ?? '',
            cellular: updates['cellular'] ?? '',
            email: updates['email'] ?? '',
            passengers: parseInt(updates['passengers']) || 0,
            parkingFrom: updates['newParkingFrom'] ?? '',
            contact: updates['contact'] ?? false,
            comment: updates['comment'] ?? ''
        };

        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/SelfService/SaveDetailsByOrderNumberEmail`;

        const result = this.http
            .post<any>(URL, model, { 'headers': headers })
            .pipe(map(update => {
                return update
            }),
                catchError(this.handleError)
            );
        return result;
    }

    private handleError(error: Response | any) {
        const errMsg = error.message
            ? error.message
            : error.status
                ? `${error.status} - ${error.statusText}`
                : 'Server error';
        console.error(`handleBookingService.handleError ${errMsg}`);
        return throwError(error);
    }
}